import axios from "axios";
import Cookies from "js-cookie";
import { API_URL } from "../../HelperAxios/const";
import store from "./store";

export const REFRESH_COOKIE = "token-siraj_refresh";

const cookieBase = {
  domain: window.location.hostname,
  secure: window.location.protocol === "https:",
  sameSite: "Lax",
};

function tokenExpiry(token) {
  const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
  const data = JSON.parse(atob(payload));
  return new Date(data.exp * 1000);
}

export function readRefreshToken() {
  return Cookies.get(REFRESH_COOKIE) || null;
}

export function saveRefreshToken(token) {
  if (!token) return;
  Cookies.set(REFRESH_COOKIE, token, {
    ...cookieBase,
    expires: tokenExpiry(token),
  });
}

export function clearRefreshToken() {
  Cookies.remove(REFRESH_COOKIE, cookieBase);
}

function apiBase() {
  if (!API_URL) return "/";
  return API_URL.endsWith("/") ? API_URL : `${API_URL}/`;
}

export function requestRefresh(refreshToken) {
  return axios
    .post(
      `${apiBase()}auth/refresh_user`,
      { refreshToken },
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "58b53900-9ab8-4367-b328-4a17f6818833",
          "accept-language": (
            localStorage.getItem("lang") || "en"
          ).toLowerCase(),
        },
      }
    )
    .then((response) => response.data || {});
}

let pending = null;

export function refreshOnce() {
  if (pending) return pending;
  const refreshToken = readRefreshToken();
  if (!refreshToken) {
    return Promise.reject(new Error("No refresh token"));
  }

  pending = requestRefresh(refreshToken)
    .then((data) => {
      saveRefreshToken(data.refreshToken);
      const currentUser = store.tokenObject.value.userState;
      const nextUser = currentUser || data.user || null;
      if (nextUser && "password" in nextUser) delete nextUser.password;
      store.tokenObject.set({
        auth: { token: data.accessToken, type: "Bearer" },
        userState: nextUser,
      });
      void import("./savedAccounts").then((mod) => {
        mod.rememberRefreshedSession(data);
      });
      return data;
    })
    .catch(async (error) => {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        try {
          const mod = await import("./savedAccounts");
          await mod.recoverAfterRefreshFailure();
        } catch (recoverError) {
          clearRefreshToken();
          store.tokenObject.set({ auth: null });
        }
      }
      throw error;
    })
    .finally(() => {
      pending = null;
    });

  return pending;
}
